import { Metadata } from '../../../../../utils/spds/metadata';
import Super from '../../../core/button.gjs';
import styles from './primary.module.scss';

const METADATA = Metadata.define({
  description: `
    Agent button used to perform an action.

    Extends the SPDS Core Button component.
  `,
  name: 'Agent Button',
  resources: {
    figma:
      'https://www.figma.com/design/pAAy83e2t59aYqNR2Vhi2C/Sidekick-AI?node-id=55-646&p=f&m=dev',
    zeroheight: 'https://www.simplepractice.design/1d0abbc0a/v/0/p/56566c-buttons',
  },
});

export default class SpdsActionButtonAgentPrimary extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-button spds-action-button';
  variantClass = 'spds-action-button-agent-primary';
  variantStyles = styles;

  get variant() {
    return 'agent-primary';
  }
}

export const ACTION_BUTTON_AGENT_PRIMARY_METADATA = SpdsActionButtonAgentPrimary.metadata;
